module.exports = __webpack_public_path__ + "img/map-lg-2x.a6ae0193.jpg";